import { createRoot } from 'react-dom/client';
import App from './App';

// Import PWA assets so Webpack includes them in the build
import './manifest.json';
import './sw.js';
import './pwa-assets/pwa-icon-96.png';
import './pwa-assets/pwa-icon-128.png';
import './pwa-assets/pwa-icon-256.png';
import './pwa-assets/pwa-icon-512.png';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

// Register Service Worker for PWA (Web Browser only)
if (!window.electron && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('./sw.js')
      .then((registration) => {
        console.log('PWA Service Worker registered with scope: ', registration.scope);
      })
      .catch((err) => {
        console.error('PWA Service Worker registration failed: ', err);
      });
  });
}

// calling IPC exposed from preload script
window.electron?.ipcRenderer.once('ipc-example', (arg) => {
  // eslint-disable-next-line no-console
  console.log(arg);
});
window.electron?.ipcRenderer.sendMessage('ipc-example', ['ping']);
